import React from 'react'
import styles from './StatIcon.module.scss'

type Color = 'primary' | 'success' | 'warning' | 'info' | 'error' | 'muted'

interface StatIconProps {
  icon: React.ReactNode
  color?: Color
  className?: never
}

const colorMap: Record<Color, string> = {
  primary: styles.primary, success: styles.success, warning: styles.warning,
  info: styles.info, error: styles.error, muted: styles.muted,
}

export const StatIcon: React.FC<StatIconProps> = ({ icon, color = 'primary' }) => {
  if (color === 'muted') {
    return <div className={colorMap[color]}>{icon}</div>
  }
  return (
    <div className={[styles.icon, colorMap[color]].join(' ')}>{icon}</div>
  )
}
